require('./bootstrap');

import "./modules/cardSlider";
import "./modules/bannerSlider";
import "./modules/ratingSlider";
import "./modules/gallerySlider";
import "./modules/separateCar";
// import "./modules/homepageForm";
// import "./modules/customSelect";
import "./modules/header";
import "./modules/footer";
